export default __webpack_public_path__ + "static/media/BikeGray.ce5d7427.png";